<audio #audioSource
       [id]="'audio_'+audio.name"
       (loadeddata)="onLoadedData()"
       preload="auto"
       (seeked)="onLoadedData()"
       (timeupdate)="updateTime()"
       (progress)="progressEvent()"
       [attr.loop]="!audio.synchronized || undefined">
  <source [src]="audio.url" type="audio/mpeg"/>
</audio>
